import { render, staticRenderFns } from "./QuantumLeapIntro.vue?vue&type=template&id=fc28b05c&scoped=true"
import script from "./QuantumLeapIntro.vue?vue&type=script&lang=js"
export * from "./QuantumLeapIntro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc28b05c",
  null
  
)

export default component.exports